export enum TokenVaultStatuses {
  OPEN = 'open',
  USED = 'used',
  EXPIRED = 'expired',
  CANCELED = 'canceled',
}
